import { render } from "./WorkView.vue?vue&type=template&id=6e0be32a"
import script from "./WorkView.vue?vue&type=script&lang=js"
export * from "./WorkView.vue?vue&type=script&lang=js"

import "./WorkView.vue?vue&type=style&index=0&id=6e0be32a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__